export enum UnavailableValuesBehavior {
  /** Show unavailable values as clickable/selectable (default behavior).
   * When an unavailable value is selected, the system will navigate to that product even if all attributes don't match. */
  Active = 'active',

  /** Show unavailable values but make them non-interactive (grayed out) */
  Disabled = 'disabled',

  /** Completely hide unavailable values from the UI */
  Hidden = 'hidden'
}
